module.exports = __webpack_public_path__ + "static/media/test17_3.c35887eb.png";